var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-slider',{staticClass:"calculateur-slider",class:[
      _vm.formatedOptions.some(function (option) { return option.length > 18; })
        ? 'calculateur-slider--small-labels'
        : ''
    ],attrs:{"data":_vm.formatedOptions,"marks":true,"contained":true,"useKeyboard":true,"tooltip":'none',"process-style":{ backgroundColor: '#21acb8' },"railStyle":{
      height: '30px',
      boxShadow: 'inset 0px 3px 7px 0px rgba(0, 0, 0, 0.2)'
    },"autofocus":""},on:{"change":_vm.onChange},model:{value:(_vm.selectedFormatedOption),callback:function ($$v) {_vm.selectedFormatedOption=$$v},expression:"selectedFormatedOption"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }